import { library } from "@fortawesome/fontawesome-svg-core";

import {
  faAddressCard,
  faAngleDown,
  faAngleLeft,
  faAngleRight,
  faAngleUp,
  faArrowLeft,
  faArrowRight,
  faArrowsAlt,
  faArrowsV,
  faAsterisk,
  faAnchor,
  faBadgePercent,
  faBadgeDollar,
  faBalanceScale,
  faBan,
  faBars,
  faBell,
  faBook,
  faBookOpen,
  faBookSpells,
  faBookmark,
  faBoxUsd,
  faBriefcase,
  faBuilding,
  faBrackets,
  faChimney,
  faCalculator,
  faCalendarAlt,
  faCalendarTimes,
  faChartLine,
  faChartPie,
  faCheck,
  faCheckCircle,
  faCheckSquare,
  faClipboardList,
  faComments,
  faCommentAltCheck,
  faClock,
  faClone,
  faCog,
  faColumns,
  faCopy,
  faCrown,
  faChevronDoubleRight,
  faDollarSign,
  faDiscDrive,
  faDownload,
  faEdit,
  faEllipsisH,
  faEllipsisV,
  faEngineWarning,
  faEuroSign,
  faExchangeAlt,
  faExclamationTriangle,
  faExclamationCircle,
  faExpand,
  faEye,
  faEyeSlash,
  faFileAlt,
  faFileCheck,
  faFileContract,
  faFileEdit,
  faFileImport,
  faFileInvoice,
  faFileInvoiceDollar,
  faFileMedical,
  faFileTimes,
  faFileImage,
  faFilesMedical,
  faFilter,
  faFlagAlt,
  faFolder,
  faFolders,
  faFolderOpen,
  faFolderTree,
  faGlasses,
  faGripLines,
  faGripLinesVertical,
  faHdd,
  faHourglassHalf,
  faHome,
  faImage,
  faInbox,
  faInboxIn,
  faInfoCircle,
  faKey,
  faLayerGroup,
  faLayerPlus,
  faList,
  faListAlt,
  faListUl,
  faLock,
  faLink,
  faMapMarkerAlt,
  faMoneyBillWave,
  faMoneyCheckAlt,
  faNetworkWired,
  faObjectGroup,
  faObjectUngroup,
  faPageBreak,
  faPaperclip,
  faPaperPlane,
  faParagraph,
  faPen,
  faPenSquare,
  faPencilAlt,
  faPercentage,
  faPhoneAlt,
  faPlus,
  faPlusCircle,
  faPoundSign,
  faPrint,
  faPuzzlePiece,
  faQuestionCircle,
  faRedo,
  faReply,
  faRupeeSign,
  faSackDollar,
  faSave,
  faSearch,
  faShapes,
  faShareSquare,
  faShieldCheck,
  faShoppingCart,
  faSignInAlt,
  faSignature,
  faSignal,
  faSlidersH,
  faSyncAlt,
  faSort,
  faSortAmountUp,
  faSortAmountDown,
  faSpinner,
  faSquare,
  faTable,
  faTag,
  faTags,
  faTextHeight,
  faTilde,
  faTimes,
  faTimesHexagon,
  faTimesCircle,
  faTrashAlt,
  faTrophyAlt,
  faUndo,
  faUnlock,
  faUser,
  faUserPlus,
  faUserCheck,
  faUserFriends,
  faUserNinja,
  faUserTag,
  faUsers,
  faYenSign,
  faImages,
  faGlobe,
  faMinus,
  faUpload,
  faAlignJustify,
  faPalette,
  faFillDrip,
  faExternalLinkAlt,
  faCreditCardFront,
  faMicroscope,
  faAt,
  faListOl,
  faMoneyCheckEdit,
  faUserCog,
  faShareAlt,
  faGift,
  faUserCircle,
} from "@fortawesome/pro-regular-svg-icons";

library.add(
  faAddressCard,
  faAngleDown,
  faAngleLeft,
  faAngleRight,
  faAngleUp,
  faArrowLeft,
  faArrowRight,
  faArrowsAlt,
  faArrowsV,
  faAsterisk,
  faAt,
  faAnchor,
  faAlignJustify,
  faBadgeDollar,
  faBadgePercent,
  faBalanceScale,
  faBan,
  faBars,
  faBell,
  faBook,
  faBookOpen,
  faBookSpells,
  faBookmark,
  faBoxUsd,
  faBrackets,
  faBriefcase,
  faBuilding,
  faCalculator,
  faCalendarAlt,
  faCalendarTimes,
  faChartLine,
  faChartPie,
  faCheck,
  faCheckCircle,
  faCheckSquare,
  faChevronDoubleRight,
  faChimney,
  faClipboardList,
  faClock,
  faClone,
  faCog,
  faColumns,
  faCopy,
  faComments,
  faCommentAltCheck,
  faCrown,
  faDiscDrive,
  faDollarSign,
  faDownload,
  faEdit,
  faEngineWarning,
  faEllipsisH,
  faEllipsisV,
  faEuroSign,
  faExchangeAlt,
  faExclamationTriangle,
  faExclamationCircle,
  faExpand,
  faEye,
  faEyeSlash,
  faFileAlt,
  faFileCheck,
  faFileContract,
  faFileEdit,
  faFileImage,
  faFileImport,
  faFileInvoice,
  faFileInvoiceDollar,
  faFileMedical,
  faFileTimes,
  faFilesMedical,
  faFilter,
  faFlagAlt,
  faFolder,
  faFolderTree,
  faFolderOpen,
  faFolders,
  faFillDrip,
  faGlasses,
  faGripLines,
  faGripLinesVertical,
  faHdd,
  faHome,
  faHourglassHalf,
  faImage,
  faImages,
  faInbox,
  faInboxIn,
  faInfoCircle,
  faKey,
  faLayerGroup,
  faLayerPlus,
  faLink,
  faList,
  faListAlt,
  faListUl,
  faListOl,
  faLock,
  faMapMarkerAlt,
  faMicroscope,
  faMinus,
  faMoneyBillWave,
  faMoneyCheckAlt,
  faNetworkWired,
  faObjectGroup,
  faObjectUngroup,
  faPageBreak,
  faPaperclip,
  faPaperPlane,
  faParagraph,
  faPen,
  faPenSquare,
  faPencilAlt,
  faPercentage,
  faPhoneAlt,
  faPlus,
  faPlusCircle,
  faPoundSign,
  faPalette,
  faPrint,
  faPuzzlePiece,
  faQuestionCircle,
  faRedo,
  faReply,
  faRupeeSign,
  faSackDollar,
  faSave,
  faSearch,
  faShapes,
  faShareSquare,
  faShieldCheck,
  faShoppingCart,
  faSignInAlt,
  faSignal,
  faSignature,
  faSlidersH,
  faSyncAlt,
  faSort,
  faSortAmountDown,
  faSortAmountUp,
  faSpinner,
  faSquare,
  faTable,
  faTag,
  faTags,
  faTextHeight,
  faTilde,
  faTimes,
  faTimesCircle,
  faTimesHexagon,
  faTrashAlt,
  faTrophyAlt,
  faUndo,
  faUnlock,
  faUser,
  faUserCheck,
  faUserPlus,
  faUserFriends,
  faUserNinja,
  faUserTag,
  faUsers,
  faYenSign,
  faGlobe,
  faUpload,
  faExternalLinkAlt,
  faCreditCardFront,
  faMoneyCheckEdit,
  faUserCog,
  faShareAlt,
  faGift,
  faUserCircle,
);



// WEBPACK FOOTER //
// ./src/fontawesome/regular.js